export const FEATURE_ENTITY_KIND = {
  CATEGORY: 'category',
  TYPE: 'type',
};

export const FEATURE_ENTITY_VIEW_MODE = {
  TABLE: 'table',
  TREE: 'tree',
};

export const FEATURE_ENTITY_VIEW_MODE_LABEL = {
  TABLE: 'Table view',
  TREE: 'Tree view',
};

export const FEATURE_TREE_FETCH_PARAMS = {
  page: 1,
  rows: 1000,
};
